import { useTranslation } from "react-i18next";

export function FaneventTitle({ badgeOnly = false }) {
  const { t } = useTranslation();
  return (
    <div>
      <h1 className={"flex items-center flex-wrap"}>
        {!badgeOnly && (
          <span className={"font-bold flex-shrink"}>
            {t("common_sitetitle")}
          </span>
        )}
        <div className={"ml-2 badge badge-outline"}>
          {t("common_onsitelabel")}
        </div>
      </h1>
    </div>
  );
}
